module.exports = __webpack_public_path__ + "assets/img/ae3e-ck.svg";